import { commonFilter } from './filter';

export default {
  pageName: 'version',
  pageId: '20011',
  pagePath: '/opinion/Stats/Version',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
